import React from "react";
import PropTypes from "prop-types";
import { TextField, makeStyles } from "@material-ui/core";
import { isSpecial, isKorea } from "../../lib/Common";
const useStyles = makeStyles({
  root: {
    paddingTop: "5%",
  },
});
function Id({
  idRef,
  id,
  onChangeId,
  errorValue,
  errorText,
  setErrorValue,
  setErrorText,
}) {
  const classes = useStyles();
  const validateBlur = ({ value }) => {
    if (isSpecial.test(value) || isKorea.test(value)) {
      idRef.current.value = "";
      idRef.current.focus();
      setErrorText("한글 or 특수문자는 입력할 수 없습니다.");
      setErrorValue(true);
    } else {
      setErrorText("");
      setErrorValue(false);
    }
  };
  return (
    <div className={classes.root}>
      <TextField
        autoFocus
        required
        inputRef={idRef}
        error={errorValue}
        helperText={errorText}
        fullWidth
        variant="filled"
        autoComplete="off"
        label="id입력"
        type="text"
        name="textFieldId"
        onBlur={(e) => {
          validateBlur(e.target);
        }}
        defaultValue={id}
        inputProps={{
          maxLength: 6,
        }}
      ></TextField>
    </div>
  );
}
Id.propType = {
  idRef: PropTypes.object,
  id: PropTypes.string,
  onChangeId: PropTypes.func,
  errorText: PropTypes.string,
  errorValue: PropTypes.bool,
  setErrorText: PropTypes.func,
  setErrorValue: PropTypes.func,
};
export default Id;
